import {
  InputRightAddon,
  InputGroup,
  FormLabel,
  HStack,
  VStack,
  styledComponentsTheme,
  Radio,
} from '@frontend/components';

import { MAX_QUANTITY_VALUE } from '../modals/Quantities/const';
import InputContainer from './InputComponents/InputContainer';

const Quantities = ({
  initialQuantities,
  quantities,
  isReadOnly,
  isMostLikelyWonQuantityEnabled,
  onChange,
}) => {
  const handleChange = (index, old, update) => {
    if (Object.keys(update).some((key) => old[key] !== update[key])) {
      // raise change if valid
      const sideEffects = {};
      if (Object.keys(update).includes('quantity') && !update.quantity) {
        sideEffects.mostLikelyWonQuantityPercent = null;
        sideEffects.isMostLikelyWonQuantity = false;
      }

      onChange(index, {
        ...old,
        ...update,
        ...sideEffects,
      });
    }
  };

  return (
    <HStack spacing={2.5}>
      <VStack spacing={1} alignItems="flex-start">
        <FormLabel textTransform="uppercase">quantity</FormLabel>
        {quantities.map((quantity, i) => (
          <InputContainer
            key={quantity.id ?? `index_${i}`}
            numberFieldProps={{
              bg:
                quantity.quantity &&
                initialQuantities?.[i]?.quantity !== quantity.quantity
                  ? styledComponentsTheme.color.interaction.modified
                  : 'inherit',
              sx: {
                '&:focus': {
                  background: 'inherit',
                },
              },
            }}
            type="number"
            autoFocus={i === 0}
            isReadOnly={isReadOnly}
            min={1}
            max={MAX_QUANTITY_VALUE}
            step={1}
            onSave={(value) =>
              handleChange(i, quantity, { quantity: value || undefined })
            }
            initialValue={quantity.quantity}
          />
        ))}
      </VStack>
      {isMostLikelyWonQuantityEnabled && (
        <VStack spacing={1} alignItems="flex-start">
          <FormLabel textTransform="uppercase">most likely to win</FormLabel>
          {quantities.map((quantity, i) => (
            <HStack
              key={quantity.id ?? `index_${i}`}
              spacing={1}
              alignItems="center"
            >
              <Radio
                isDisabled={!quantity.quantity}
                isReadOnly={isReadOnly}
                isChecked={quantity.isMostLikelyWonQuantity ?? false}
                onChange={({ target }) =>
                  handleChange(i, quantity, {
                    isMostLikelyWonQuantity: target.checked,
                    mostLikelyWonQuantityPercent: target.checked ? 100 : null,
                  })
                }
              />
              <InputGroup>
                <InputContainer
                  type="number"
                  isDisabled={!quantity.isMostLikelyWonQuantity}
                  isReadOnly={isReadOnly}
                  min={1}
                  max={100}
                  step={1}
                  onSave={(value) =>
                    handleChange(i, quantity, {
                      mostLikelyWonQuantityPercent: value,
                    })
                  }
                  initialValue={quantity.mostLikelyWonQuantityPercent}
                />
                <InputRightAddon>%</InputRightAddon>
              </InputGroup>
            </HStack>
          ))}
        </VStack>
      )}
    </HStack>
  );
};

export default Quantities;
